import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Button } from '@mui/material';
import { push } from 'connected-react-router';
import queryString from 'query-string';

import { selectQuery } from 'rdx/router';

interface SaveChangesProps {
  onSave: () => void;
  onReset: () => void;
  isSavingDisabled: boolean;
}

const SaveChanges: React.FC<SaveChangesProps> = ({ onSave, onReset, isSavingDisabled }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const query = useSelector(selectQuery);
  const handleCancel = useCallback(() => {
    onReset();
    dispatch(
      push({
        search: queryString.stringify({ ...query, mode: 'view' }),
      }),
    );
  }, [dispatch, onReset, query]);

  return (
    <Box display="flex">
      <Box mr={2}>
        <Button variant="contained" onClick={handleCancel} color="secondary">
          {intl.formatMessage({ id: 'widgets.MenuEditor.cancel' })}
        </Button>
      </Box>
      <Box>
        <Button variant="contained" color="primary" disabled={isSavingDisabled} onClick={onSave}>
          {intl.formatMessage({ id: 'widgets.MenuEditor.saveChanges' })}
        </Button>
      </Box>
    </Box>
  );
};

export default SaveChanges;
